var $ = require('jquery');
var MarkerClusterer = require('marker-clusterer-plus');
var markerClustererStyles = {
	gridSize : 30,
	styles : [{
		url : 'assets/images/design/vector-group.svg',
		height : 30,
		width : 30,
		anchor : [0, 0],
		textColor : '#ffffff',
		textSize : 16,
		fontWeight: 400,
		alt: ''
	}]
};

module.exports = {
	init: function() {
		/*
		 *
		 * Map
		 *
		 * */

		//Only load map code if it's a map page
		if (document.getElementById("property-map") !== null){

			//Images used for markers
			var iconRed = {
				path: "M16.5 11c0 3-2.5 5.5-5.5 5.5S5.5 14 5.5 11 8 5.5 11 5.5 16.5 8 16.5 11zm5.5 0c0-6.1-4.9-11-11-11S0 4.9 0 11c0 1.3.2 2.7.7 3.8l7.8 16.6C9 32.4 10 33 11 33s2-.6 2.5-1.5l7.8-16.6c.5-1.2.7-2.6.7-3.9z",
				fillColor: "#ef3f44",
				fillOpacity: 1,
				strokeWeight: 0
			};
	    	var iconBlue = {
				path: "M16.5 11c0 3-2.5 5.5-5.5 5.5S5.5 14 5.5 11 8 5.5 11 5.5 16.5 8 16.5 11zm5.5 0c0-6.1-4.9-11-11-11S0 4.9 0 11c0 1.3.2 2.7.7 3.8l7.8 16.6C9 32.4 10 33 11 33s2-.6 2.5-1.5l7.8-16.6c.5-1.2.7-2.6.7-3.9z",
				fillColor: "#0055a1",
				fillOpacity: 1,
				strokeWeight: 0
			};

	    	google.maps.visualRefresh = true;

	    	//Main init for map
			function initialize() {
		        var mapOptions = {
					zoom: 10,
					center: new google.maps.LatLng(45.078612 , -93.249035),
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					mapTypeControl: false,
					mapTypeControlOptions: {
						style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
						position: google.maps.ControlPosition.BOTTOM_CENTER
					},
					panControl: false,
					zoomControlOptions: {
						style: google.maps.ZoomControlStyle.LARGE,
						position: google.maps.ControlPosition.LEFT_BOTTOM
					},
					scaleControl: true,
					scaleControlOptions: {
						position: google.maps.ControlPosition.TOP_LEFT
					},
					streetViewControl: false,
					scrollwheel: false,
					minZoom: 9
		        };

		        var map = new google.maps.Map(document.getElementById("property-map"),
		            mapOptions);

				//do stuff for each property listing
				var $propertyListing = $('.card.property-list-item');
				var infoWindow = new google.maps.InfoWindow();

				var markerArray = [];
				var mapBounds = new google.maps.LatLngBounds();
				var oldCenter = null; //This is used to allow the map to pan back to its previous centering after the last infobox is closed

				$propertyListing.each(function() {
					var $this = $(this),
						latlon = new google.maps.LatLng($this.data('lat'),$this.data('lon'));
					var closureElement = this;
					var propertyMarker = new google.maps.Marker({
					      position: latlon,
					      map: map,
					      icon: iconRed
					  });

					mapBounds.extend(propertyMarker.getPosition());
					markerArray.push(propertyMarker);

					var boxOpen = false;

					var closureElement = this;
					var $closureElement = $(closureElement);
					$closureElement.off('mouseenter mouseleave');
					$closureElement.on({
						mouseenter : function(event) {
							if (propertyMarker) {
								propertyMarker.setIcon(iconBlue);
							}
						},
						mouseleave : function(event) {
							if (propertyMarker) {
								propertyMarker.setIcon(iconRed);
							}
						}
					});
					//swap icons when hovered
					 google.maps.event.addListener(propertyMarker, "mouseover", function(event) {
	                     $closureElement.addClass('hovered');
	                     this.setIcon(iconBlue);
	                  });
					 google.maps.event.addListener(propertyMarker, "mouseout", function(event) {
						 if ( !boxOpen ) {
							 this.setIcon(iconRed);
							 boxOpen = false;
						 }
						 $closureElement.removeClass('hovered');
					 });


					 //infoBox

					 var infoImage = $this.find('.property-list-item.image img').attr('src'),
					 	 infoTitle = $this.find('.card__heading').text(),
					 	 infoAddress = $this.find('.card__address').html(),
					 	 infoLink = $this.find('.card__fullLink').attr('href');

					 var imageTag = infoImage != undefined ? '<img src="' + infoImage + '" class="infoBox__image" />' : ''

					 var contentString = '<div class="infoBox">' +
					 						'<a class="infoBox__imageWrap" href="' + infoLink + '">' + imageTag + '</a>' +
											'<div class="infoBox__content">' +
												'<h3 class="infoBox__heading"><a href="' + infoLink + '">' + infoTitle + '</a></h3>' +
												'<div class="infoBox__address">' + infoAddress + '</div>' +
												'<a class="infoBox__link" href="' + infoLink + '">Community Info</a>' +
											'</div>' +
					 					'</div>';


					 google.maps.Map.prototype.panToWithOffset = function(latlng, offsetX, offsetY) {
						    var map = this;
						    var ov = new google.maps.OverlayView();
						    ov.onAdd = function() {
						        var proj = this.getProjection();
						        var aPoint = proj.fromLatLngToContainerPixel(latlng);
						        aPoint.x = aPoint.x+offsetX;
						        aPoint.y = aPoint.y+offsetY;
						        map.panTo(proj.fromContainerPixelToLatLng(aPoint));
						    };
						    ov.draw = function() {};
						    ov.setMap(this);
						};

					 google.maps.event.addListener(propertyMarker, 'click', function() {
						if (oldCenter === null) {
							oldCenter = map.getCenter();
						}
					 	infoWindow.close();

					 	for (i=0; i< markerArray.length; i++ ) {
					 		markerArray[i].setIcon(iconRed);
					 	}
					 	this.setIcon(iconBlue);
	                    boxOpen = true;

					 	infoWindow.setContent(contentString)
					    infoWindow.open(map,propertyMarker);
					    map.panToWithOffset(latlon, 0, -100);


					  });


					 google.maps.event.addListener(infoWindow, 'closeclick', function() {
						 if (oldCenter !== null) {
							 map.panTo(oldCenter);
							 oldCenter = null;
						 }
						 propertyMarker.setIcon(iconRed);
						 boxOpen = false;
					 });

					 google.maps.event.addListener(map, 'idle', function() { $('.gm-style').removeClass('gm-style');  });

				});
				var markerCluster = new MarkerClusterer(map, markerArray, markerClustererStyles);

				if (markerArray.length > 0) {
					map.setCenter(mapBounds.getCenter());
					map.fitBounds(mapBounds, 5);
					if (markerArray.length == 1) {
						var listener = google.maps.event.addListener(map, "idle", function() {
						  if (map.getZoom() > 11) map.setZoom(11);
						  google.maps.event.removeListener(listener);
						});
					}
				}
		      } // end main google map init

	    	// go go gadget maps!
		     google.maps.event.addDomListener(window, 'load', initialize);


		} // END MAP if

		/*
		 *
		 * list item animation
		 *
		 */
		var $title = $('.property-listing-container .listing-content h3');

		$title.hover(function(){
			$(this).parent().parent().find('a.thumbnailLink img.listing-thumb').addClass('hovered')
		}, function(){
			$(this).parent().parent().find('a.thumbnailLink img.listing-thumb').removeClass('hovered')
		});

		/*
		 *
		 * "Scroll Down" message
		 *
		 */
		var distance = 50;
		var scrollingElContainer = $('.property-results-list-contentContainer');
		var scrollingEl = $('.property-results--list .grid');

		var scrollDownClass = 'property-results__scrollDown';
		var scrollDownActiveClass = 'property-results__scrollDown--show';

		$('.property-results--list').append('<div class="' + scrollDownClass + '">Scroll Down</div>');

		var scrollDownEl = $('.' + scrollDownClass);

		if (scrollingEl.outerHeight() > scrollingElContainer.outerHeight() + distance) {
			scrollDownEl.addClass(scrollDownActiveClass);

			var scrollTest = function() {
				if ( scrollingElContainer.scrollTop() > distance ) {
					scrollDownEl.removeClass(scrollDownActiveClass);

					scrollingElContainer.off('scroll', scrollTest);
				}
			}

			scrollingElContainer.on('scroll', scrollTest);
		}
	}
};
